import React from 'react';
import { useMediaQuery } from 'react-responsive';
import Container from '../Container/Container';
import { Wrapper, FlexWrapp, Text, Section, Box, TitleStyled, TextBox } from './AboutClinic.styled';
import dataAboutUs from '../../resources/dataAboutUs.json';
import cosmetologistIMG from '../../images/cosmetologist.jpg';

const AboutClinic = () => {

    const isDesktopOrTablet = useMediaQuery({ query: '(min-width: 768px)' });
    const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

    return (
        <Section>
            <Container>
                <div id="back-to-top-anchor"></div>
                <Wrapper>
                    <FlexWrapp>
                        {isMobile && (
                            <>
                                <Box firstBox>
                                    <TitleStyled>{dataAboutUs.title}</TitleStyled>
                                    <div style={{ minHeight: '364px', alignSelf: 'center' }}>
                                        <img
                                            // width='500px'
                                            alt='Portrait'
                                            src={cosmetologistIMG}
                                            loading="lazy"
                                        ></img>
                                        <span>Alicja Łyszyk</span>

                                    </div>
                                </Box></>)}
                        <TextBox>
                            {isDesktopOrTablet && (
                                <TitleStyled>{dataAboutUs.title}</TitleStyled>)}
                            <Text>{dataAboutUs.subtitle}</Text>
                        </TextBox>
                        {isDesktopOrTablet && (<Box firstBox>
                            <img
                                alt='Portrait'
                                src={cosmetologistIMG}
                                loading="lazy"
                            ></img>
                            <span>Alicja Łyszyk</span>
                        </Box>)}
                    </FlexWrapp>
                </Wrapper>
            </Container>
        </Section>
    )
}

export default AboutClinic